module.exports = __webpack_public_path__ + "static/media/user-circle.6eb38020.svg";